module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "videoPlaceHolder"
  }, [_c('div', {
    staticClass: "videoThumbnail",
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_c('img', {
    staticClass: "video-thumbnail",
    attrs: {
      "src": _vm.video.imageUrl,
      "alt": _vm.video.name
    }
  }), _vm._v(" "), _c('svg', {
    attrs: {
      "width": "55",
      "height": "65"
    }
  }, [_c('polygon', {
    staticStyle: {
      "fill": "rgb(0,159,227)"
    },
    attrs: {
      "points": "55,33 0,0 0,65"
    }
  })])]), _vm._v(" "), (_vm.showModal) ? _c('div', [_c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container videoPlayer"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.video.name))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticClass: "resp-container"
  }, [_c('iframe', {
    staticClass: "resp-iframe",
    attrs: {
      "slot": "body",
      "src": _vm.video.videoUrl,
      "frameborder": "0",
      "allowfullscreen": ""
    },
    slot: "body"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  })])], 2)])])])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a2be15a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Video.vue
// module id = 449
// module chunks = 1